module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"title":"選択期間来店客数"}}')
  delete Component.options._Ctor
}
